import { render, staticRenderFns } from "./Pglaz.vue?vue&type=template&id=3038a307&scoped=true"
import script from "./Pglaz.vue?vue&type=script&lang=js"
export * from "./Pglaz.vue?vue&type=script&lang=js"
import style0 from "./Pglaz.vue?vue&type=style&index=0&id=3038a307&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3038a307",
  null
  
)

export default component.exports